import ArticleRoundedIcon from '@mui/icons-material/ArticleRounded'
import HomeRoundedIcon from '@mui/icons-material/HomeRounded'
import PersonRoundedIcon from '@mui/icons-material/PersonRounded'
import SearchIcon from '@mui/icons-material/Search'
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded'
import { Box, Container as MuiContainer, useTheme } from '@mui/material'
import { Dispatch } from '@reduxjs/toolkit'
import jwt_decode from 'jwt-decode'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { string } from 'yup'

import * as routes from '../../config/constants'
import { IsBottomNavigationItem } from '../../interfaces/IsBottomNavigationItem'
import BottomNavigation from '../../shared/BottomNavigation'
import { getUser, setLoggedUser, setTokenUser } from '../../store/auth'

const Container = () => {
  const { t } = useTranslation()
  const items: IsBottomNavigationItem[] = [
    {
      id: '1',
      label: t('screens.container.search_button_text'),
      icon: <SearchIcon />,
      value: routes.SEARCH,
    },
    {
      id: '2',
      label: t('screens.container.tickets_button_text'),
      icon: <ArticleRoundedIcon />,
      value: routes.TICKETS,
    },
    {
      id: '3',
      label: t('screens.container.profile_button_text'),
      icon: <PersonRoundedIcon />,
      value: routes.PROFILE,
    },
    {
      id: '4',
      label: t('screens.container.settings_button_text'),
      icon: <SettingsRoundedIcon />,
      value: routes.SETTINGS,
    },
    {
      id: '5',
      label: t('screens.container.home_button_text'),
      icon: <HomeRoundedIcon />,
      value: routes.CARS,
    },
  ]
  const dispatch = useDispatch<Dispatch<any>>()
  const navigate = useNavigate()
  const [selectedItem, setSelectedItem] = useState(routes.CARS)
  const user = useSelector(getUser)
  const { zIndex } = useTheme()

  const handleChange = (event: React.SyntheticEvent<Element, Event>, newValue: string) => {
    setSelectedItem(newValue)
    navigate(newValue)
  }

  // useEffect(() => {
  //   const loginStatus = localStorage.getItem('token')
  //   if (loginStatus !== null) {
  //     const decodedToken = jwt_decode(loginStatus)
  //     dispatch(setLoggedUser(decodedToken))
  //     dispatch(setTokenUser(loginStatus))
  //   }
  // }, [])
  if (user === undefined) return null

  return (
    <Box width='100%'>
      <BottomNavigation
        items={items}
        onChange={handleChange}
        sx={{
          bottom: 0,
          left: 0,
          right: 0,
          display: 'flex',
          zIndex: zIndex.tooltip + 10000000,
        }}
        value={selectedItem}
      />
    </Box>
  )
}

export default Container
